import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';

export default function AwardsRecognitions({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [awardsRecognitions, setAwardsRecognitions] = useState({});

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;
      const awards = await assignValueById(activities, 17);
      setAwardsRecognitions(awards);
    };

    loadActivities();
  }, [activities]);

  if (isFetching) {
    return <>...loading</>;
  }

  return (
    <>
      {awardsRecognitions.length > 0 ? (
        <ProfileSection
          title="Premios y Reconocimientos"
          subtitleLyrics={{
            subtitle: '',
            lyrics: awardsRecognitions[0]?.description,
          }}
        />
      ) : null}
    </>
  );
}

AwardsRecognitions.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
